"use client";

import _slicedToArray from "/buddy/remotehvac-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import classNames from 'classnames';
import useLayoutEffect from "rc-util/es/hooks/useLayoutEffect";
export default function Progress(_ref) {
  var percent = _ref.percent,
    prefixCls = _ref.prefixCls;
  var dotClassName = "".concat(prefixCls, "-dot");
  var holderClassName = "".concat(dotClassName, "-holder");
  var hideClassName = "".concat(holderClassName, "-hidden");
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    render = _React$useState2[0],
    setRender = _React$useState2[1];
  // ==================== Visible =====================
  useLayoutEffect(function () {
    if (percent !== 0) {
      setRender(true);
    }
  }, [percent !== 0]);
  // ==================== Progress ====================
  var safePtg = Math.max(Math.min(percent, 100), 0);
  var viewSize = 100;
  var borderWidth = viewSize / 5;
  var radius = viewSize / 2 - borderWidth / 2;
  var circumference = radius * 2 * Math.PI;
  var renderCircle = function renderCircle(circleClassName, style) {
    return /*#__PURE__*/React.createElement("circle", {
      className: classNames(circleClassName, "".concat(dotClassName, "-circle")),
      r: radius,
      cx: "50",
      cy: "50",
      strokeWidth: borderWidth,
      style: style
    });
  };
  // ===================== Render =====================
  if (!render) {
    return null;
  }
  return /*#__PURE__*/React.createElement("span", {
    className: classNames(holderClassName, "".concat(dotClassName, "-progress"), safePtg <= 0 && hideClassName)
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 ".concat(viewSize, " ").concat(viewSize),
    // biome-ignore lint/a11y/noNoninteractiveElementToInteractiveRole: progressbar could be readonly
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": safePtg
  }, renderCircle("".concat(dotClassName, "-circle-bg")), renderCircle('', {
    strokeDasharray: "".concat(circumference * safePtg / 100, " ").concat(circumference * (100 - safePtg) / 100),
    strokeDashoffset: "".concat(circumference / 4)
  })));
}